import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DsAuthJWTToken, DsAuthService } from '@direction/auth';
import { GlobalUser } from 'src/app/core/models/global.user.model';
import { StatusSignalR } from 'src/app/core/models/statusSignalR';
import { TurnstileService } from 'src/app/core/services/turnstile.service';
import { HelpersService } from './../../../services/helpers.service';
import { UserService } from './../../../services/user.service';

@Component({
  selector: 'app-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})
export class UserDetailComponent {
  @Input() name: string = '';
  @Input() avatarImage: any;
  loggedUser: GlobalUser = new GlobalUser();
  dataDsAuthJWTToken: any = new DsAuthJWTToken();
  token: string = '';
  constructor(
    private user: UserService,
    private router: Router,
    public helpersService: HelpersService,
    private authService: DsAuthService,
    private tokenService: DsAuthJWTToken,
    private turnstileService: TurnstileService
  ) {
    this.token = this.dataDsAuthJWTToken.token;
  }

  userLogout() {
    this.authService
      .logout()
      .pipe()
      .subscribe(() => {
        this.loggedUser = new GlobalUser();
      });
    this.turnstileService.eventSignalR$.next({ status: StatusSignalR.LogoutUser });
    this.helpersService.reloadTo(this.router, '/auth', null);
  }

  resetPassword() {
    this.authService.$authComponent.next({ form: 'resetPassword', token: '', user: this.loggedUser });
  }
}
